import { ChevronDown } from "lucide-react";
import HelpQ from "./HelpQ";
import { writeDraggedChatContext } from "../utils/chatContextDrag";

function AppRightRailReportSection({
  open,
  reportCount,
  reportsWithMeta,
  highlightedReportKeys,
  openReportDropdown,
  chatContextPickMode,
  onToggle,
  onToggleDropdown,
  onOpenReport,
  styles,
}) {
  return (
    <section className={styles.rightRailSection} data-tour-id="reports">
      <button
        type="button"
        className={`${styles.rightRailSectionHeader} ${
          open ? styles.rightRailSectionHeaderOpen : ""
        }`}
        onClick={onToggle}
      >
        <span className={styles.rightRailSectionHeaderTitle}>
          Reports
          {/* <span className={styles.rightRailSectionCount}>{reportCount}</span> */}
        </span>
        <span className={styles.rightRailSectionHeaderActions}>
          <HelpQ stepIndex={2} title="Your raw data" />
          <ChevronDown size={12} strokeWidth={2} aria-hidden="true" />
        </span>
      </button>
      {open ? (
        <div className={styles.rightRailSectionBody}>
          {reportsWithMeta.map((report) => {
            const isGenerated = Boolean(report.latestReportId || report.meta);
            if (report.comingSoon) {
              return (
                <div
                  key={report.key}
                  className={`${styles.rightRailReportItem} ${styles.rightRailReportItemComingSoon}`}
                  aria-disabled="true"
                >
                  <span className={styles.rightRailReportItemName}>{report.label}</span>
                  <span className={styles.rightRailReportDropdownBadge}>coming soon</span>
                </div>
              );
            }

            if (report.hasDropdown) {
              const isOpen = openReportDropdown === report.key;
              const isHighlighted = highlightedReportKeys.has(report.key);

              return (
                <div key={report.key} className={styles.rightRailReportGroup}>
                  <button
                    type="button"
                    className={`${styles.rightRailReportItem} ${
                      isHighlighted ? styles.rightRailReportItemActive : ""
                    } ${
                      !isGenerated ? styles.rightRailItemDisabled : ""
                    } ${
                      chatContextPickMode && isGenerated
                        ? styles.rightRailItemWiggle
                        : ""
                    }`}
                    onClick={() => {
                      if (!isGenerated) return;
                      onToggleDropdown(isOpen ? null : report.key);
                    }}
                    disabled={!isGenerated}
                    draggable={Boolean(chatContextPickMode && isGenerated)}
                    onDragStart={(event) =>
                      writeDraggedChatContext(event, {
                        key: report.key,
                        label: report.label,
                        type: "report",
                        reportId: report.latestReportId || null,
                        collectionName: report.collectionName || null,
                        source: "report",
                        sourceLabel: "Report",
                      })
                    }
                  >
                    <span className={styles.rightRailReportItemName}>{report.label}</span>
                    {!isGenerated ? (
                      <span className={styles.rightRailReportItemMeta}>
                        Not generated yet
                      </span>
                    ) : null}
                    <ChevronDown
                      size={12}
                      strokeWidth={2}
                      aria-hidden="true"
                      className={`${styles.rightRailReportChevron} ${
                        isOpen ? styles.rightRailReportChevronOpen : ""
                      }`}
                    />
                  </button>
                  {isOpen ? (
                    <div className={styles.rightRailReportDropdown}>
                      <button
                        type="button"
                        className={`${styles.rightRailReportDropdownItem} ${
                          !isGenerated ? styles.rightRailReportDropdownItemDisabled : ""
                        }`}
                        onClick={() => {
                          if (!isGenerated) return;
                          onOpenReport(report.key);
                        }}
                        disabled={!isGenerated}
                      >
                        SEO Report
                        <span className={styles.rightRailReportDropdownMeta}>
                          {report.meta || "Not generated yet"}
                        </span>
                      </button>
                      <button
                        type="button"
                        className={`${styles.rightRailReportDropdownItem} ${styles.rightRailReportDropdownItemDisabled}`}
                        disabled
                      >
                        AEO Report
                        <span className={styles.rightRailReportDropdownBadge}>coming soon</span>
                      </button>
                    </div>
                  ) : null}
                </div>
              );
            }

            return (
              <button
                key={report.key}
                type="button"
                className={`${styles.rightRailReportItem} ${
                  highlightedReportKeys.has(report.key)
                    ? styles.rightRailReportItemActive
                    : ""
                } ${
                  !isGenerated ? styles.rightRailItemDisabled : ""
                } ${
                  chatContextPickMode && isGenerated
                    ? styles.rightRailItemWiggle
                    : ""
                }`}
                onClick={() => {
                  if (!isGenerated) return;
                  onOpenReport(report.key);
                }}
                disabled={!isGenerated}
                draggable={Boolean(chatContextPickMode && isGenerated)}
                onDragStart={(event) =>
                  writeDraggedChatContext(event, {
                    key: report.key,
                    label: report.label,
                    type: "report",
                    reportId: report.latestReportId || null,
                    collectionName: report.collectionName || null,
                    source: "report",
                    sourceLabel: "Report",
                  })
                }
              >
                <span className={styles.rightRailReportItemName}>{report.label}</span>
                <span className={styles.rightRailReportItemMeta}>
                  {report.meta || "Not generated yet"}
                </span>
              </button>
            );
          })}
        </div>
      ) : null}
    </section>
  );
}

export default AppRightRailReportSection;
